const { Type } = require('@sinclair/typebox');
const { merge } = require('lodash');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');

/** Builds the TypeBox schema fragment for the MultiPickerShortText form element. */
function asDataDictionary(hNode, context) {
    const { id, title, propertyName, foreignNamespace, foreignRelation, required } = hNode;

    // This block tells us the foreign namespaces/relations should exist
    // and the filters will tell us about properties we'd expect to be on there
    let [_subDataDictionary = {}, _partialTypeDefinition = {}] = hNode.children?.reduce(
        ([sdd, ptd], child) => {
            const [_subDataDictionary = {}, _partialTypeDefinition = {}] = context.extractFromChild(child, context);
            return [
                merge(sdd, _subDataDictionary),
                moduleRegistration.mergePartialTypeDefinitions(ptd, _partialTypeDefinition)
            ];
        },
        [{}, {}]
    ) ?? [{}, {}];

    // Merge the child subdictionaries with any filter-contributed data
    const subDataDictionary = _subDataDictionary;

    // Determine optional/editable flags based on the context (readOnly) and the required flag.
    let optional;
    let editable;
    if (!context?.readOnly) {
        editable = true;
        if (!required) {
            optional = true;
        }
    }

    // Helper to wrap a schema as optional if needed
    const maybeOptional = (schema) => (optional ? Type.Optional(schema) : schema);

    const normalizedPropertyName = propertyName || `${foreignNamespace}:${foreignRelation}`;
    const schemaTitle = title || normalizedPropertyName;

    // Build the array schema with string items
    const itemSchema = Type.String({
        title: 'Item',
        'x-dataType': 'string'
    });

    const arraySchema = maybeOptional(
        Type.Array(itemSchema, {
            title: schemaTitle,
            'x-id': id,
            'x-dataType': 'array',
            'x-propertyName': normalizedPropertyName,
            'x-optional': !!optional,
            'x-editable': !!editable,
            'x-foreignNamespace': foreignNamespace,
            'x-foreignRelation': foreignRelation
        })
    );

    // The partial type definition is a plain object with the property schema
    const partialTypeDefinition = {
        [normalizedPropertyName]: arraySchema
    };

    return [subDataDictionary, partialTypeDefinition];
}

module.exports = { asDataDictionary };
